import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import Layout from "web/components/Layout";
import Breadcrumb from "web/components/Breadcrumb";
import PalletsSidebar from "web/components/PalletsSidebar";
import FilterIcon from "web/assets/images/filterIcon.png";

import Bids from "./Bids";
import MobileView from "./MobileView/MobileView";
import styled from "styled-components";
import { fetchLanguageContentNew } from "redux/actions/language";
import InventoryFilterModal from "./InventoryFilterModal";

const MyBids = ({ myOffersOnInvData, type, activePage, expanded, activeSearch, callBackFun, }) => {
  const dispatch = useDispatch();
  const [inventoryFilterPopUpModal, setInventoryFilterPopUpModal] = useState(false);
  const toggleInventoryFilterPopUpModal = () => setInventoryFilterPopUpModal(!inventoryFilterPopUpModal);

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const languageContentNew = useSelector((state) => state.language.languageContentNew);
  const [pageLanguageContents, setPageLanguageContents] = useState();
  useEffect(() => {
    if (languageContentNew.MyBids_Page) setPageLanguageContents(languageContentNew.MyBids_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage));
  }, [languageContentNew]);

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
    },
  ];
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible)

  const myOffersListTableView = (dataList, header) => {
    return (
      <MainSection>
        <MobileView
          offersInvData={dataList}
          displayNameHeader={header}
          callBackFun={callBackFun}
          type={header === 'Buy Now Offers' ? 'buyNowOffers' : 'StdOffers'}
        />
        <div className="community-details-cards web-view-menu">
          <div class={"community-details-headerSeller seller"}>
            <div class="community-name">
              <h4>{header}</h4>
            </div>
          </div>
          <Bids
            offersOnInvData={dataList}
            callBackFun={callBackFun}
            type={header === 'Buy Now Offers' ? 'buyNowOffers' : 'StdOffers'}
          />
        </div>
      </MainSection>
    )
  }

  return (
    <Layout selectedSearch={"MyOfferBids"} topBarViewMobile={'hide'}>
      {loaderVisible && <Spinner />}

      <div className="breadcrumb-wrapper-mybids">
        <Breadcrumb
          breadcrumbArr={breadcrumbMapArr}
          selected={pageLanguageContents?.Breadcrumb[2]?.PalletOffers}
          title=""
        />
        <>
          <img
            src={FilterIcon}
            alt=""
            onClick={toggleInventoryFilterPopUpModal}
          />
        </>
      </div>

      <div className="custom-wrapper">
        <div className="pd-right-nav">
          <PalletsSidebar
            postType={type}
            activePage={activePage}
            expandedPallet={expanded}
            activeSearch={activeSearch}
          />
        </div>
        <div className="left-content">
          {myOffersOnInvData?.buyNowList?.length > 0 && myOffersListTableView(myOffersOnInvData?.buyNowList, 'Buy Now Offers')}
          {myOffersOnInvData?.offerList?.length > 0 && myOffersListTableView(myOffersOnInvData?.offerList, pageLanguageContents?.Bids_Header[7]?.Offers)}
          {myOffersOnInvData?.length === 0 && <NoRecordFound>{pageLanguageContents?.Bids_Header[8]?.NoRecord}</NoRecordFound>}
        </div>
      </div>

      <InventoryFilterModal
        isOpen={inventoryFilterPopUpModal}
        toggle={toggleInventoryFilterPopUpModal}
        callBack={toggleInventoryFilterPopUpModal}
        callBackFun={(value) => callBackFun(value)}
      />
    </Layout>
  );
};

export default MyBids;

const NoRecordFound = styled.div`
  text-align: center;
  padding-top: 5%;
  padding-bottom: 5%;
  background: white;
`;

const MainSection = styled.div`
  margin-bottom: 35px;
  .community-details-cards {
    display: block;
  }
  > h6 {
    box-shadow: 0 0 20px 0 rgb(0 0 0 / 8%);
    padding: 7px 12px;
    background-color: #0a1f30;
    color: #fff;
    font-size: 18px;
    border-radius: 5px 5px 0 0;
  }

  .web-view-menu {
    display: block;
  }
  @media (max-width: 560px) {  
    /* .community-details-cards {
      display: none;
    } */
    .web-view-menu {
      display: none;
    }
  }
`;
